import css from 'styled-jsx/css';
import React from 'react';
// TODO: Migrate module so that you don’t import from the corp project in a global module
/* eslint-disable restrict-imports/restrict-imports */
import SectionTitle from 'corp/components/UI/SectionTitle';
import { Section } from 'react-scale/containers/corp/backfills/batch/components/Section';
import IncompleteBatchAction from 'react-scale/corp/components/BeeTTS/IncompleteBatch';
import MarkBatchReadyAction from 'react-scale/corp/components/BeeTTS/MarkBatchReady';
import BlacklistTaskersAction from 'react-scale/corp/components/BeeTTS/BlacklistTaskers';
import HealthCheckAction from 'react-scale/corp/components/BeeTTS/HealthCheck';
import ForgiveTaskersAction from 'react-scale/corp/components/BeeTTS/ForgiveTaskers';
import UploadTasksAction from 'react-scale/corp/components/BeeTTS/UploadTasks';
import CreateTemplateTaskAction from 'react-scale/corp/components/BeeTTS/CreateTemplateTask';
import UploadEagleBatchesAction from 'react-scale/corp/components/BeeTTS/UploadEagleBatches';
import { IUserJson } from '@scale/shared/types/user';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query-v4';

const style = css`
  .root .two-columns {
    display: flex;
  }
  .root .two-columns section {
    flex-basis: 50%;
  }
  .root .two-columns section.disabled {
    color: rgba(0, 0, 0, 0.3);
  }
  .root .three-columns {
    display: flex;
  }
  .root .three-columns section {
    flex-basis: 33%;
  }
  .root .three-columns section.disabled {
    color: rgba(0, 0, 0, 0.3);
  }
  .root .disallowed-task-types {
    font-weight: bold;
    color: red;
  }
  .root .warning {
    font-weight: bold;
    color: red;
  }
  .root.disabled section {
    color: rgba(0, 0, 0, 0.3);
  }
`;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const BatchActions: React.FC<{ user: IUserJson }> = ({ user }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="root">
        <SectionTitle title="Bee TTS Actions" />
        <Section name={`Mark Batch as Incomplete`} forceHidden={true}>
          <IncompleteBatchAction />
        </Section>
        <Section name={`Mark Batch as Ready for Customer`} forceHidden={true}>
          <MarkBatchReadyAction user={user} />
        </Section>
        <Section name={`Blacklist Taskers`} forceHidden={true}>
          <BlacklistTaskersAction />
        </Section>
        <Section name={`Projects Health Check`} forceHidden={true}>
          <HealthCheckAction />
        </Section>
        <Section name={`Forgive Taskers`} forceHidden={true}>
          <ForgiveTaskersAction />
        </Section>
        <Section name={`Upload Tasks`} forceHidden={true}>
          <UploadTasksAction />
        </Section>
        <Section name={`Create template task`} forceHidden={true}>
          <CreateTemplateTaskAction />
        </Section>
        <Section name={`Upload Eagle Batches`} forceHidden={true}>
          <UploadEagleBatchesAction />
        </Section>
        <style jsx>{style}</style>
      </div>
    </QueryClientProvider>
  );
};

export default BatchActions;
